import { BoundaryPathTypeFlag } from '../../../../consts';
import type DxfArrayScanner from '../../../DxfArrayScanner';
import type { ScannerGroup } from '../../../DxfArrayScanner';
import { createParser } from '../../../shared/parserGenerator';
import { EdgeBoundaryPathDataSnippets } from './edge';
import PolylineSnippets from './polyline';

export default function parseBoundaryPathData(
    curr: ScannerGroup,
    scanner: DxfArrayScanner,
) {
    // assume start with 92
    const boundaryPathData = {
        boundaryPathTypeFlag: curr.value,
    };

    /* eslint-disable no-bitwise */
    const isPolyline = (boundaryPathData.boundaryPathTypeFlag & BoundaryPathTypeFlag.Polyline) !== 0;
    /* eslint-enable no-bitwise */

    const next = scanner.next();

    if (isPolyline) {
        createParser(PolylineSnippets)(next, scanner, boundaryPathData);
    } else {
        createParser(EdgeBoundaryPathDataSnippets)(next, scanner, boundaryPathData);
    }

    return boundaryPathData;
}
